import { useAppContext, useQuery } from "@thriwe-2-0/thriwe-ui-utils";

export const useCountriesQuery = () => {
  const context = useAppContext();
  const {
    instances: { apiRepository },
  } = context;

  return useQuery<Country[], Error>({
    queryKey: ["countries"],
    queryFn: async () => {
      try {
        const response = await apiRepository?.getCountryCode({});
        return response?.data || [];
      } catch (e) {
        return [];
        throw new Error("Failed to fetch countries");
      }
    },
    gcTime: 120000,
    staleTime: 120000,
    enabled: true,
  });
};

export function isRegisterComponentVisible(
  referenceId: string,
  tempUserId: string
): boolean {
  return !(
    referenceId == null ||
    referenceId.trim() == "" ||
    tempUserId == null ||
    tempUserId.trim() == ""
  );
}

export interface Country {
  name?: string;
  code?: string;
  flag?: string;
  supported?: boolean;
  currency?: string;
  countryISOCode?: string;
}
